/**
 * Lifecycle policy API seam (contract §11).
 *
 * Default export `lifecycleApi`, every method resolves to the response BODY (never the
 * axios envelope) — same `unwrap` shape as `gateway/api.js`, which this module deliberately
 * mirrors for the step-up header: there is no second implementation of "how a step-up token
 * becomes a header", only the gateway's one primitive (contract §6, "There is no second
 * mint").
 *
 * Relative imports throughout (not the "@/" alias): "@/" is unmapped under Jest
 * (craco.config.js), and every lifecycle component takes an injectable `api` prop for
 * exactly this reason — see `useLifecyclePolicy.js` and `LifecyclePolicyPanel.jsx`.
 */
import { api } from "../../lib/api";
import { stepUpHeaders } from "../../gateway/api";
import { LIFECYCLE_PATHS, UPCOMING_DAYS_DEFAULT, SENDS_LIMIT_DEFAULT } from "./contract";

const unwrap = (p) => p.then((r) => r.data);

export const lifecycleApi = {
  getPolicy: () => unwrap(api.get(LIFECYCLE_PATHS.policy)),
  // §6 PUT /policy: a partial deep patch, gated by a fresh single-use X-Stepup-Token.
  putPolicy: (patch, stepupToken) =>
    unwrap(api.put(LIFECYCLE_PATHS.policy, patch, stepUpHeaders(stepupToken))),
  getUpcoming: (days = UPCOMING_DAYS_DEFAULT) =>
    unwrap(api.get(LIFECYCLE_PATHS.upcoming, { params: { days } })),
  getSends: (limit = SENDS_LIMIT_DEFAULT) =>
    unwrap(api.get(LIFECYCLE_PATHS.sends, { params: { limit } })),
  runNow: () => unwrap(api.post(LIFECYCLE_PATHS.run)),
};

export default lifecycleApi;
